// import React from "react";
// import { CircularProgressbarWithChildren, buildStyles } from "react-circular-progressbar";
// import "react-circular-progressbar/dist/styles.css";
// import { Box, Grid, Typography } from "@mui/material";

// const UsageChart = ({ value, title }) => {
//   const gradientId = `${(/\s+/g, "-")}-${value}`; 

//   return (
//     <div style={{ textAlign: "center", width: "150px" }}>
//       <CircularProgressbarWithChildren
//         value={value}
//         styles={buildStyles({
//           pathColor: `url(#${gradientId})`,
//           trailColor: "#F5F5F5",
//           strokeLinecap: "round",
//         })}
//         strokeWidth={12}
//       >
//         <div style={{ fontSize: "16px", fontWeight: "500", color: "#424242" }}>
//           {value}%
//         </div>
//       </CircularProgressbarWithChildren>

//       <svg style={{ height: 0 }}>
//         <defs>
//           <linearGradient id={gradientId} gradientTransform="rotate(100)">
//             <stop
//               offset="40%"
//               stopColor={"#F2653A"} // Static start color
//             />
//             <stop
//               offset="100%"
//               stopColor={"#AA218E"} // Static end color
//             />
//           </linearGradient>
//         </defs>
//       </svg>

//       <p style={{ marginTop: "2px", fontWeight: "500", color: "#424242" }}>{title}</p>
//     </div>
//   );
// };

// export default UsageChart;

import React from "react";
import { CircularProgressbarWithChildren, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { Box, Typography } from "@mui/material";
import moment from "moment";

const UsageChart = ({ value, maxValue, displayValue, title }) => {
  const gradientId = `${(/\s+/g, "-")}-${value}`;
  const todayDate = moment().format("DD MMM YYYY");
  return (
    <div style={{ textAlign: "center", width: "150px" }}>
      <CircularProgressbarWithChildren
        value={value}
        maxValue={maxValue} // Set the maximum value for the progress bar
        styles={buildStyles({
          pathColor: `url(#${gradientId})`,
          trailColor: "#F5F5F5",
          strokeLinecap: "round",
        })}
        strokeWidth={12}
      >
        <div style={{ fontSize: "16px", fontWeight: "500", color: "#424242" }}>
          {displayValue} {/* Display the formatted time */}
        </div>
      </CircularProgressbarWithChildren>

      <svg style={{ height: 0 }}>
        <defs>
          <linearGradient id={gradientId} gradientTransform="rotate(100)">
            <stop
              offset="40%"
              stopColor={"#F2653A"} // Static start color
            />
            <stop
              offset="100%"
              stopColor={"#AA218E"} // Static end color
            />
          </linearGradient>
        </defs>
      </svg>

      <p style={{ marginTop: "2px", fontWeight: "500", color: "#424242" }}>{title}</p>
    </div>
  );
};

export default UsageChart;